// extracted by mini-css-extract-plugin
module.exports = {"root":"Menu_root__1B0B-","maxHeightDisabled":"Menu_maxHeightDisabled__2eiPI"};